import React from "react";
import { Line } from "react-chartjs-2";

const TabLineChart = ({ data = [], term, year, month, quarter }) => {
  // Only tabs you want to show
  const tabs = ["SALES", "HUMAN_RESOURCE", "EXPERIENCES_OF_WORK"];
  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth(); // 0-based

  // 🧩 Parse "YYYYMM" → readable month/year
  const parseYearMonth = (ym) => {
    if (!ym || ym.length !== 6)
      return { monthLabel: "Unknown", monthIndex: currentMonth, year: currentYear };
    const y = ym.slice(0, 4);
    const m = parseInt(ym.slice(4, 6), 10);
    return { monthLabel: monthNames[m - 1], monthIndex: m - 1, year: y };
  };

  // 🧩 Filter relevant tabs
  const filtered = data.filter(d => tabs.includes(d.tabName?.toUpperCase()));

  // 🧩 Build labels
  let labels = [];

  if (term === "monthly") {
    let monthLabel = "Unknown";
    let labelYear = year || currentYear;

    if (month) {
      const monthStr = String(month).trim();
      if (!isNaN(monthStr)) {
        const idx = parseInt(monthStr, 10) - 1;
        monthLabel = monthNames[idx] || monthNames[currentMonth];
      } else {
        const formatted = monthStr.charAt(0).toUpperCase() + monthStr.slice(1).toLowerCase();
        monthLabel = monthNames.includes(formatted) ? formatted : monthNames[currentMonth];
      }
    } else if (filtered.length) {
      const parsed = parseYearMonth(filtered[0].yearMonth);
      monthLabel = parsed.monthLabel;
      labelYear = parsed.year;
    }

    labels = [`${monthLabel} ${labelYear}`];
  } else if (term === "quarterly") {
    const quarterMonths = {
      1: [0,1,2],
      2: [3,4,5],
      3: [6,7,8],
      4: [9,10,11]
    };
    labels = (quarterMonths[quarter] || [0,1,2]).map(
      i => `${monthNames[i]} ${year || currentYear}`
    );
  } else if (term === "yearly") {
    labels = monthNames.map(m => `${m} ${year || currentYear}`);
  }

  // 🧩 Group tab data by label
  const groupedData = {};
  tabs.forEach(tab => groupedData[tab] = {});
  filtered.forEach(item => {
    const tab = item.tabName.toUpperCase();
    const { monthLabel, year: ymYear } = parseYearMonth(item.yearMonth);
    const label = `${monthLabel} ${ymYear}`;
    groupedData[tab][label] = (groupedData[tab][label] || 0) + (item?.uniqueUsers || item?.count  || 0);
  });

  // 🧩 Prepare chart datasets
  const datasets = tabs.map((tab, i) => ({
    label: tab.replace(/_/g, " "),
    data: labels.map(label => groupedData[tab]?.[label] || 0),
    borderColor: ["rgb(255, 99, 132)","rgb(53, 162, 235)","rgb(53, 192, 215)"][i],
    backgroundColor: ["rgba(255, 99, 132, 0.5)","rgba(53, 162, 235, 0.5)","rgba(53, 192, 215, 0.5)"][i],
    borderWidth: 2,
    pointRadius: 5,
    pointHoverRadius: 7,
    fill: false,
    tension: 0
  }));

  const chartData = { labels, datasets };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.parsed.y;
            const month = labels[context.dataIndex];
            return `${label}\n${month}: ${value} users`;
          }
        }
      },
      legend: { position: "top" }
    },
    scales: { y: { beginAtZero: true } }
  };

  return (
    <div style={{ height: "350px", width: "100%" }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default TabLineChart;
